/*
 * LB Cores por nome – pinta as bolinhas de cor a partir do NOME da cor.
 *
 * Porte de vitrine-saas frontend/src/lib/coresPorNome.ts (espelho de
 * backend/src/vitrine/domains/catalog/cores_por_nome.py): a loja e o Vitrine
 * dão o MESMO tom para o mesmo nome. Mudou o dicionário lá? Mude aqui também.
 *
 * Vale para todo elemento com data-lb-cor="<nome>": define --swatch-background
 * com a cor lisa ou metade/metade ("OFF/ROSA"). Amostra nativa do admin
 * (swatch.color / swatch.image) não recebe o atributo e sempre vence.
 */
(function () {
  'use strict';

  var BASE_CORES = {
    'BRANCO': ['#FFFFFF', []], 'BRANCA': ['#FFFFFF', ['BRANCO']], 'WHITE': ['#FFFFFF', ['BRANCO']],
    'OFF': ['#F5F1E6', ['BRANCO']], '0FF': ['#F5F1E6', ['BRANCO']],
    'OFFWHITE': ['#F5F1E6', ['BRANCO']], 'PEROLA': ['#F2EBDD', ['BRANCO']],
    'MARFIM': ['#FFFDF0', ['BRANCO']], 'GELO': ['#EEF2F3', ['BRANCO', 'CINZA']],
    'NEVE': ['#FBFBFB', ['BRANCO']], 'CREME': ['#F3E5C0', []], 'CREAM': ['#F3E5C0', []],
    'PORCELANA': ['#F1EEE8', []], 'LINHO': ['#E9DFCC', []], 'CRISTAL': ['#EAF4F8', []],
    'TRANSPARENTE': ['#EEF2F4', []], 'PRETO': ['#1A1A1A', []], 'PRETA': ['#1A1A1A', ['PRETO']],
    'BLACK': ['#1A1A1A', ['PRETO']], 'ONIX': ['#1F1F1F', ['PRETO']], 'CINZA': ['#8A8A8A', []],
    'GREY': ['#8A8A8A', ['CINZA']], 'GRAY': ['#8A8A8A', ['CINZA']], 'MESCLA': ['#A6A6A6', ['CINZA']],
    'GRANITO': ['#6E6E6E', ['CINZA']], 'PRATA': ['#C0C0C0', ['CINZA']],
    'CHUMBO': ['#4A4A4A', ['CINZA']], 'GRAFITE': ['#3B3B3B', ['CINZA']],
    'FUMACA': ['#9EA3A8', ['CINZA']], 'AZUL': ['#2E6FD8', []], 'AZL': ['#2E6FD8', ['AZUL']],
    'BLUE': ['#2E6FD8', ['AZUL']], 'MARINHO': ['#1B2A4E', ['AZUL']], 'NAVY': ['#1B2A4E', ['AZUL']],
    'JEANS': ['#4A6FA5', ['AZUL']], 'CEU': ['#87CEEB', ['AZUL']], 'SKY': ['#87CEEB', ['AZUL']],
    'CELESTE': ['#9ACEEB', ['AZUL']], 'ROYAL': ['#2546B8', ['AZUL']], 'BIC': ['#2546B8', ['AZUL']],
    'COBALTO': ['#0047AB', ['AZUL']], 'ANIL': ['#3F51B5', ['AZUL']], 'INDIGO': ['#3F51B5', ['AZUL']],
    'TURQUESA': ['#30C5C0', ['AZUL', 'VERDE']], 'TIFFANY': ['#81D8D0', ['AZUL', 'VERDE']],
    'PETROLEO': ['#1D4E5F', ['AZUL', 'VERDE']], 'VERDE': ['#2E9E4F', []],
    'GREEN': ['#2E9E4F', ['VERDE']], 'MUSGO': ['#5B6B2F', ['VERDE']],
    'MILITAR': ['#4B5320', ['VERDE']], 'OLIVA': ['#708238', ['VERDE']],
    'LIMAO': ['#B5E61D', ['VERDE']], 'AGUA': ['#7FD8C8', ['VERDE', 'AZUL']],
    'JADE': ['#00A86B', ['VERDE']], 'SALVIA': ['#9CAF88', ['VERDE']],
    'MENTA': ['#98E2C6', ['VERDE']], 'ERVA': ['#6B8E23', ['VERDE']], 'GRAMA': ['#4CAF50', ['VERDE']],
    'ASPARGO': ['#87A96B', ['VERDE']], 'BANDEIRA': ['#009B3A', ['VERDE']],
    'ESMERALDA': ['#50C878', ['VERDE']], 'PISTACHE': ['#A8C686', ['VERDE']], 'ROSA': ['#F48FB1', []],
    'PINK': ['#E91E8C', ['ROSA']], 'ROSE': ['#E8A0B0', ['ROSA']], 'BLUSH': ['#F4C2C2', ['ROSA']],
    'SALMAO': ['#FA8072', ['ROSA']], 'CORAL': ['#FF7F6A', ['ROSA', 'LARANJA']],
    'PESSEGO': ['#FFCBA4', ['ROSA', 'LARANJA']], 'NUDE': ['#E3BC9A', []],
    'FRAMBOESA': ['#C72C48', ['ROSA']], 'SAKURA': ['#F7C6D5', ['ROSA']],
    'CHERRY': ['#C2185B', ['ROSA', 'VERMELHO']], 'CHICLETE': ['#FF77A8', ['ROSA']],
    'GOIABA': ['#E4717A', ['ROSA']], 'MELANCIA': ['#FC6C85', ['ROSA', 'VERMELHO']],
    'FUCSIA': ['#E0218A', ['ROSA']], 'MAGENTA': ['#C2185B', ['ROSA']], 'VERMELHO': ['#D32F2F', []],
    'VERMELHA': ['#D32F2F', ['VERMELHO']], 'RED': ['#D32F2F', ['VERMELHO']],
    'VINHO': ['#7B1E2E', ['VERMELHO']], 'BORDO': ['#7B1E2E', ['VERMELHO']],
    'MARSALA': ['#8E3B46', ['VERMELHO']], 'RUBI': ['#9B111E', ['VERMELHO']],
    'CEREJA': ['#9B111E', ['VERMELHO']], 'TERRACOTA': ['#C8664A', ['VERMELHO', 'LARANJA']],
    'TELHA': ['#B5523B', ['VERMELHO', 'LARANJA']], 'BEETROOT': ['#8E2043', ['VERMELHO']],
    'AMARELO': ['#F1C40F', []], 'AMARELA': ['#F1C40F', ['AMARELO']],
    'YELLOW': ['#F1C40F', ['AMARELO']], 'MOSTARDA': ['#D4A017', ['AMARELO']],
    'MOSTARDE': ['#D4A017', ['AMARELO']], 'OURO': ['#D4AF37', ['AMARELO']],
    'DOURADO': ['#D4AF37', ['AMARELO']], 'DOURADA': ['#D4AF37', ['AMARELO']],
    'GIRASSOL': ['#FFC512', ['AMARELO']], 'OCRE': ['#CC9933', ['AMARELO']],
    'BUTTER': ['#F8E7A1', ['AMARELO']], 'PALHA': ['#E6D690', ['AMARELO']],
    'CANARIO': ['#FFEF00', ['AMARELO']], 'BANANA': ['#F7E27A', ['AMARELO']],
    'LARANJA': ['#F57C00', []], 'ORANGE': ['#F57C00', ['LARANJA']],
    'TANGERINA': ['#F28500', ['LARANJA']], 'COBRE': ['#B87333', ['LARANJA']],
    'BRONZE': ['#A97142', []], 'FERRUGEM': ['#A0522D', ['LARANJA', 'MARROM']],
    'ROXO': ['#7B3FA0', []], 'ROXA': ['#7B3FA0', ['ROXO']], 'PURPLE': ['#7B3FA0', ['ROXO']],
    'LILAS': ['#C8A2C8', ['ROXO']], 'UVA': ['#5E2A6B', ['ROXO']],
    'LAVANDA': ['#B9A6D9', ['ROXO', 'LILAS']], 'VIOLETA': ['#8A2BE2', ['ROXO']],
    'AMEIXA': ['#6B2D5C', ['ROXO']], 'BERINJELA': ['#4B2140', ['ROXO']],
    'ORQUIDEA': ['#DA70D6', ['ROXO', 'LILAS']], 'MARROM': ['#7B4A2E', []],
    'MERROM': ['#7B4A2E', ['MARROM']], 'BROWN': ['#7B4A2E', ['MARROM']],
    'CARAMELO': ['#C68E4E', ['MARROM']], 'CHOCOLATE': ['#5A3825', ['MARROM']],
    'CACAU': ['#6B4226', ['MARROM']], 'CAFE': ['#6F4E37', ['MARROM']],
    'TABACO': ['#6F4E37', ['MARROM']], 'CONHAQUE': ['#8B4513', ['MARROM']],
    'CANELA': ['#8B5A2B', ['MARROM']], 'CAPUCCINO': ['#A67B5B', ['MARROM']],
    'CAPPUCCINO': ['#A67B5B', ['MARROM']], 'CAQUI': ['#C3B091', ['BEGE']],
    'KAKI': ['#C3B091', ['BEGE']], 'CAMELO': ['#C19A6B', ['MARROM', 'BEGE']],
    'BEGE': ['#D9C9A8', []], 'AREIA': ['#D8C7A1', ['BEGE']], 'ARGILA': ['#B66A50', ['MARROM']],
    'CHAMPANHE': ['#F2E3C6', ['BEGE']], 'MATE': ['#B9A27F', ['BEGE']],
    'FENDI': ['#C1B6A3', ['BEGE']]
  };

  var MODIFICADORES = {
    CLARO: 'claro', CLARA: 'claro', LIGHT: 'claro', CL: 'claro', BEBE: 'bebe', ESCURO: 'escuro',
    ESCURA: 'escuro', ESCURI: 'escuro', DARK: 'escuro', PROFUNDO: 'escuro', ESC: 'escuro',
    NEON: 'neon', FLUOR: 'neon', FLUORESCENTE: 'neon', MEDIO: 'medio', MEDIA: 'medio'
  };

  var SEPARADORES = /\s*(?:\/|\+|&|\s+E\s+|\s+C\/\s*|\s+COM\s+)\s*/;
  var PALAVRAS = /[\s.,;:()-]+/;
  var LIMITE_TONS = 2;
  var SEM_COR = '#dddddd';

  function tem(obj, chave) { return Object.prototype.hasOwnProperty.call(obj, chave); }

  function normalizar(texto) {
    return texto.toUpperCase().normalize('NFD').replace(/[̀-ͯ]/g, '')
      .replace(/\bOFF[\s-]*WHITE\b/g, 'OFFWHITE');
  }

  function mod1(x) { return ((x % 1) + 1) % 1; }

  function rgbParaHls(r, g, b) {
    var maxc = Math.max(r, g, b), minc = Math.min(r, g, b);
    var lum = (maxc + minc) / 2;
    if (maxc === minc) return [0, lum, 0];
    var faixa = maxc - minc;
    var s = lum <= 0.5 ? faixa / (maxc + minc) : faixa / (2 - maxc - minc);
    var rc = (maxc - r) / faixa, gc = (maxc - g) / faixa, bc = (maxc - b) / faixa;
    var h;
    if (r === maxc) h = bc - gc;
    else if (g === maxc) h = 2 + rc - bc;
    else h = 4 + gc - rc;
    return [mod1(h / 6), lum, s];
  }

  function canalHls(m1, m2, hue) {
    var h = mod1(hue);
    if (h < 1 / 6) return m1 + (m2 - m1) * h * 6;
    if (h < 0.5) return m2;
    if (h < 2 / 3) return m1 + (m2 - m1) * (2 / 3 - h) * 6;
    return m1;
  }

  function hlsParaRgb(h, lum, s) {
    if (s === 0) return [lum, lum, lum];
    var m2 = lum <= 0.5 ? lum * (1 + s) : lum + s - lum * s;
    var m1 = 2 * lum - m2;
    return [canalHls(m1, m2, h + 1 / 3), canalHls(m1, m2, h), canalHls(m1, m2, h - 1 / 3)];
  }

  function canal(x) { return Math.floor(Math.max(0, Math.min(1, x)) * 255 + 0.5); }
  function hex2(n) { var s = n.toString(16).toUpperCase(); return s.length < 2 ? '0' + s : s; }

  function aplicar(base, mods) {
    var hexBase = BASE_CORES[base][0];
    if (!mods.length) return hexBase;
    var rgb = [1, 3, 5].map(function (i) { return parseInt(hexBase.slice(i, i + 2), 16) / 255; });
    var hls = rgbParaHls(rgb[0], rgb[1], rgb[2]);
    var h = hls[0], lum = hls[1], s = hls[2];
    mods.forEach(function (m) {
      if (m === 'claro') lum = lum + (1 - lum) * 0.55;
      else if (m === 'bebe') lum = lum + (1 - lum) * 0.7;
      else if (m === 'escuro') lum = lum * 0.6;
      else if (m === 'neon') { s = 1; lum = Math.min(Math.max(lum, 0.5), 0.6); }
    });
    if (['PRETO', 'PRETA', 'BLACK'].indexOf(base) !== -1 &&
        mods.some(function (m) { return m === 'claro' || m === 'bebe'; })) {
      lum = Math.max(lum, 0.45);
    }
    var c = hlsParaRgb(h, lum, s);
    return '#' + hex2(canal(c[0])) + hex2(canal(c[1])) + hex2(canal(c[2]));
  }

  function tonsDaParte(parte) {
    var achadas = [];
    parte.split(PALAVRAS).forEach(function (palavra) {
      if (!palavra) return;
      if (tem(BASE_CORES, palavra)) {
        var ultima = achadas[achadas.length - 1];
        if (ultima && !ultima[1].length && BASE_CORES[palavra][1].indexOf(ultima[0]) !== -1) {
          ultima[0] = palavra; // "AZUL MARINHO" → MARINHO
          return;
        }
        achadas.push([palavra, []]);
      } else if (tem(MODIFICADORES, palavra) && achadas.length) {
        achadas[achadas.length - 1][1].push(MODIFICADORES[palavra]);
      }
    });
    return achadas.map(function (a) { return aplicar(a[0], a[1]); });
  }

  /** Até 2 tons distintos citados no nome, na ordem em que aparecem. */
  function tonsPeloNome(nome) {
    if (!nome || !nome.trim()) return [];
    var tons = [];
    var partes = normalizar(nome).split(SEPARADORES);
    for (var i = 0; i < partes.length; i++) {
      var achados = tonsDaParte(partes[i]);
      for (var j = 0; j < achados.length; j++) {
        if (tons.indexOf(achados[j]) === -1) tons.push(achados[j]);
        if (tons.length >= LIMITE_TONS) return tons;
      }
    }
    return tons;
  }

  /** Fundo CSS da bolinha: cor lisa ou metade/metade. */
  function fundoPeloNome(nome) {
    var tons = tonsPeloNome(nome);
    if (!tons.length) return null;
    return tons[1] ? 'linear-gradient(90deg, ' + tons[0] + ' 50%, ' + tons[1] + ' 50%)' : tons[0];
  }

  var cache = {};
  function pintar(raiz) {
    (raiz || document).querySelectorAll('[data-lb-cor]:not([data-lb-pintada])').forEach(function (el) {
      var nome = el.getAttribute('data-lb-cor');
      if (!tem(cache, nome)) cache[nome] = fundoPeloNome(nome);
      var fundo = cache[nome];
      el.setAttribute('data-lb-pintada', '');
      if (!fundo) {
        // Sem cor reconhecida no nome: mantém o que o Liquid já pintou, ou o cinza de sempre.
        if (el.classList.contains('swatch--unavailable')) {
          el.classList.remove('swatch--unavailable');
          el.style.setProperty('--swatch-background', SEM_COR);
        }
        return;
      }
      el.classList.remove('swatch--unavailable');
      el.style.setProperty('--swatch-background', fundo);
    });
  }

  window.lbCoresPorNome = { tonsPeloNome: tonsPeloNome, fundoPeloNome: fundoPeloNome, pintar: pintar };

  function iniciar() {
    pintar(document);
    // Filtros, paginação e rolagem infinita trocam os cards sem recarregar a página.
    // só reage quando entra algo que tem cor para pintar, e no máximo uma vez a cada 100 ms
    var agendado = false;
    new MutationObserver(function (mudancas) {
      if (agendado) return;
      for (var i = 0; i < mudancas.length; i++) {
        var nos = mudancas[i].addedNodes;
        for (var j = 0; j < nos.length; j++) {
          var n = nos[j];
          if (n.nodeType === 1 && (n.hasAttribute('data-lb-cor') || n.querySelector('[data-lb-cor]:not([data-lb-pintada])'))) {
            agendado = true;
            setTimeout(function () { agendado = false; pintar(document); }, 100);
            return;
          }
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar);
  else iniciar();
})();
